import { ProposalStatus } from 'src/app/models/enum/proposal-status.enum';
import { UserContactInfo } from 'src/app/models/user-contact-info.model';
import { ProposalDocumentInfo } from './proposal-document-info.model';

export class ApprovalRequest {
	proposalId?: number;
	comment?: string;
	type: string;
	budget: number;
	approvedBudget: number;
	createdOn: Date;
	lastUpdatedOn: Date;
	senderName: string;
	proposalStatusId: ProposalStatus;
	currentUser: UserContactInfo;
	boardMemberType: number;
	documents: ProposalDocumentInfo[];

	public static getOrderedDocuments(request: ApprovalRequest) {
		return request.documents.sort((first, second) => (first.description || first.name) < (second.description || second.name) ? -1 : 1);
	}
}
